export default __webpack_public_path__ + "static/media/striding-feather-quotidians.9165473e.jpg";